// ---- Furniture piece names ----
// The single source of truth for which pieces the `furnish` structure op can
// place — a dependency-free leaf so content validation (validate.ts: headless
// server + browser bundle + gen script) can check piece names WITHOUT pulling
// in THREE/toon via the real FURNITURE registry (furniture/index.ts, which
// derives its key type from this list so the two can't drift).

export const FURNITURE_PIECES = [
  "rug", "bench", "stool", "bookshelf", "chandelier", "barrel", "crate",
  "chest", "roundTable", "bed", "fireplace",
  "throne", "banquetTable", "fourPosterBed",
  "shopCounter", "shopSign",
] as const;

export type FurniturePiece = (typeof FURNITURE_PIECES)[number];

/** Per-piece numeric `args` the `furnish` op accepts, with the default each
 *  arg falls back to — MIRRORS the `?? …` fallbacks in the FURNITURE adapters
 *  (furniture/index.ts); change a default in both places. Typed by
 *  FurniturePiece so adding/renaming a piece without updating this table is a
 *  compile error. The studio Builder's inspector reads it for its "+ arg"
 *  picker + seeds. */
export const PIECE_ARGS: Record<FurniturePiece, Record<string, number>> = {
  rug: { w: 3, d: 2 },
  bench: { length: 2.2, face: Math.PI / 2 },
  stool: { y0: 0, face: 0 },
  bookshelf: { faceX: 1, y0: 0 },
  chandelier: { ceilingY: 3 },
  barrel: {},
  crate: { s: 0.9 },
  chest: { y0: 0 },
  roundTable: { y0: 0 },
  bed: { y0: 0 },
  fireplace: { nx: 0, nz: -1, y0: 0 },
  throne: {},
  banquetTable: { length: 6 },
  fourPosterBed: { y0: 0 },
  shopCounter: { length: 4.2 },
  shopSign: { nx: -1, nz: 0 },
};
